import React from "react";
import PropTypes from "prop-types";
import { Typography, Stack } from "@mui/material";

const IconWithTitle = ({ icon, title,iconSize }) => {
  return (
    <Stack sx={{display:"flex"}}>
      <Stack direction="row" sx={{alignItems: "center",}}>
      <Stack
        sx={{
          alignItems: "center",
          justifyContent: "center",
          "& .MuiSvgIcon-root": {
            fontSize: iconSize,
          },
        }}
      >
        {icon}
      </Stack>
      <Stack>
        <Typography
        component="div"
        fontWeight="600"
        fontSize="57.6px"
        marginLeft="10px"
        fontFamily="Raleway, sans-serif"
      >
        {title}
      </Typography>
      </Stack>
      </Stack>
     
      
    </Stack>
  );
};

IconWithTitle.propTypes = {
  icon: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
};

export default IconWithTitle;